<template>
    <router-view/>
</template>

<script>

export default {
    name: 'App',
    data(){
        return {
        }
    },
    mounted() {

    },
    methods: {
    }
};
</script>

<style>
</style>
